import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import { Avatar } from '@fiverr-private/fit';
import ExpertInfo from '../ExpertInfo';
import Badge from '../Badge';
import { ExpertModal } from '../ExpertModal';
import NotableClients from '../NotableClients';

import './style.scss';

const ExpertProfile = ({
    isPro,
    countryCode,
    proficientLanguages,
    profilePhoto,
    sellerName,
    notableClients,
    repeatScore,
    translationFlag,
    isOnline = false
}) => {
    const hasRepeatScore = !isEmpty(repeatScore);
    const hasNotableClients = !isEmpty(notableClients);

    return (
        <div className="expert-profile">
            <ExpertModal username={sellerName} translationFlag={translationFlag}>
                <Avatar size={76}
                    className="avatar"
                    containerClassName={'m-r-20 avatar-wrapper'}
                    username={sellerName}
                    src={profilePhoto}
                    isOnline={isOnline}
                    showOnlineIndicator={isOnline}
                    onlineIndicatorSize={12}
                    onlineIndicatorPosition={
                        Avatar.ONLINE_INDICATOR_POSITIONS.BOTTOM_RIGHT
                    }/>
            </ExpertModal>

            <ExpertInfo className="expert-info"
                isPro={isPro}
                sellerName={sellerName}
                countryCode={countryCode}
                proficientLanguages={proficientLanguages}
                translationFlag={translationFlag}
                repeatScore={repeatScore}/>

            {(hasRepeatScore || hasNotableClients) &&
                <div className="highlights m-b-8 flex">
                    {hasRepeatScore &&
                        <Badge className="m-t-12 m-r-24" type={Badge.TYPE.LOYALTY}/>
                    }
                    {hasNotableClients &&
                        <NotableClients className="m-t-8" clients={notableClients}
                            username={sellerName}/>
                    }
                </div>
            }
        </div>
    );
};

ExpertProfile.propTypes = {
    isPro: bool,
    countryCode: string,
    proficientLanguages: arrayOf(
        shape({
            name: string,
            level: number
        })
    ),
    profilePhoto: string,
    sellerName: string,
    notableClients: arrayOf(object),
    isOnline: bool,
    translationFlag: bool,
    repeatScore: shape({
        score: bool
    })
};

const mapStateToProps = ({ seller: { isOnline } = {} }) => ({
    isOnline
});

const ConnectedExpertProfile = connect(mapStateToProps)(ExpertProfile);

export { ExpertProfile };
export default ConnectedExpertProfile;
